import toast from './toast';
export function permissionCheck(pagename,action) {
    try {
        let parseData = localStorage.getItem('permission');
        let m_status = localStorage.getItem('m_status');
        let permission=JSON.parse(parseData);
        if(permission===null){
            return false;
        }
        let masterAccess=['institution','menu'];
        if(m_status==='M'){
            return {permission:masterAccess.indexOf(pagename)!==-1?'View,New,Edit':'View'};
        }

        return permission.find((val)=>{
            //console.log(val.pagename);
            let actions= val.permission.split(',');
            if(val.pagename===pagename && actions.indexOf(action)!==-1){
                return 1;
            }else if(val.pagename===pagename && !action){
                return 1;
            }
        }); 
    } catch (error) {
        toast.error(error.message);
    }
} 


// WEBPACK FOOTER //
// ./src/core/Permission.js